import { render, staticRenderFns } from "./main-menu.vue?vue&type=template&id=20e221d5&scoped=true&"
import script from "./main-menu.vue?vue&type=script&lang=ts&"
export * from "./main-menu.vue?vue&type=script&lang=ts&"
import style0 from "./main-menu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./main-menu.vue?vue&type=style&index=1&id=20e221d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e221d5",
  null
  
)

export default component.exports